var _g, _ellipse, _ellipse2, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3002",
    "data-name": "Group 3002",
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.887,
    height: 30.413,
    viewBox: "0 0 29.887 30.413",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_766",
    "data-name": "Groupe 766",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_88",
    "data-name": "Ellipse 88",
    transform: "translate(4.399 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1764",
    "data-name": "Path 1764",
    d: "M-536.767,390.852a7.247,7.247,0,0,1-7.239-7.238,7.248,7.248,0,0,1,7.239-7.239,7.247,7.247,0,0,1,7.238,7.239A7.247,7.247,0,0,1-536.767,390.852Zm0-12.218a4.986,4.986,0,0,0-4.98,4.98,4.985,4.985,0,0,0,4.98,4.979,4.984,4.984,0,0,0,4.979-4.979A4.985,4.985,0,0,0-536.767,378.633Z",
    transform: "translate(544.006 -376.374)",
    fill: "#3e3e3e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trac\\xE9_390",
    "data-name": "Trac\\xE9 390",
    transform: "translate(0 15.272)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1765",
    "data-name": "Path 1765",
    d: "M-531.81,413.932h-15.071a4.1,4.1,0,0,1-3.392-1.8,4.1,4.1,0,0,1-.423-3.821,12.141,12.141,0,0,1,11.35-7.714A12.143,12.143,0,0,1-528,408.315a4.1,4.1,0,0,1-.423,3.821A4.1,4.1,0,0,1-531.81,413.932Zm-7.536-11.072a9.892,9.892,0,0,0-9.25,6.286,1.823,1.823,0,0,0,.19,1.72,1.819,1.819,0,0,0,1.525.807h15.071a1.819,1.819,0,0,0,1.525-.807,1.823,1.823,0,0,0,.19-1.72,9.894,9.894,0,0,0-9.249-6.286Z",
    transform: "translate(550.985 -400.601)",
    fill: "#3e3e3e"
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_212",
    "data-name": "Ellipse 212",
    cx: 6.589,
    cy: 6.589,
    rx: 6.589,
    ry: 6.589,
    transform: "translate(16.708 17.234)",
    fill: "#3e3e3e"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_214",
    "data-name": "Ellipse 214",
    cx: 2.534,
    cy: 2.028,
    rx: 2.534,
    ry: 2.028,
    transform: "translate(9.507 15.545)",
    fill: "#3e3e3e"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1980",
    "data-name": "Path 1980",
    d: "M245.24-271.622l-2.167,9.269,5.363.1-2.182-9.838Z",
    transform: "translate(-233.86 289.649)",
    fill: "#3e3e3e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-close",
    d: "M3.181,2.571,5.017.734A.43.43,0,1,0,4.409.125L2.572,1.963.735.125A.43.43,0,1,0,.127.734L1.963,2.571.127,4.409a.43.43,0,0,0,.609.609L2.572,3.18,4.409,5.017a.43.43,0,0,0,.609-.609Z",
    transform: "translate(23.278 20.119) rotate(45)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUser);
export default __webpack_public_path__ + "static/media/addUser.32e7f229ea33bfbb0398e58e192f3269.svg";
export { ForwardRef as ReactComponent };